import { render, staticRenderFns } from "./ViewNotificationModal.vue?vue&type=template&id=7cd1710e&"
import script from "./ViewNotificationModal.vue?vue&type=script&lang=js&"
export * from "./ViewNotificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports